import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ViewGroup from 'components/settings/Groups/ViewGroup';
import EditGroup from 'components/settings/Groups/EditGroup';
import Groups from 'components/settings/Groups/Groups';
import CreateGroup from 'components/settings/Groups/CreateGroup';

const GroupsContainer = () => {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route
                path={`${match.path}/:id/view`}
                exact
                component={ViewGroup}
            />
            <Route
                path={`${match.path}/:id/edit`}
                exact
                component={EditGroup}
            />
            <Route
                path={`${match.path}/create`}
                exact
                component={CreateGroup}
            />
            <Route component={Groups} />
        </Switch>
    );
};

export default GroupsContainer;
